import * as React from 'react';
import { graphql } from 'gatsby';
import _ from 'lodash';
import { useMemo } from 'react';
import { DWTCContext } from '../utils/context';
import MAP_COMPONENTS from '../components';
import Footer from '../components/Footer';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import TopBar from '../components/Topbar';
import '../main.css';

export default function Page({ data, pageContext }) {
  const dwtcPage = _.get(data, 'umbraco.dwtcPage', null);
  const lang = _.get(pageContext, 'lang', 'en-US');
  const langCode = _.get(pageContext, 'langCode', 'en');
  const allEvents = _.get(pageContext, 'allEvents', []);
  if (!dwtcPage) return null;
  
  const settings =
    dwtcPage.contentTypeAlias === 'dwtcPage'
      ? dwtcPage.settings.items[0].children.items.find(
          (item) => item.contentTypeAlias === 'dwtcSettings',
        )
      : dwtcPage.children.items[0];
      
  const translationsFirst =
    dwtcPage.contentTypeAlias === 'dwtcPage'
      ? dwtcPage.translations.items[0].children.items[0].children.items.find(
          (item) => item.contentTypeAlias === 'translations',
        )
      : dwtcPage.children.items[0].children.items.find(
        (item) => item.contentTypeAlias === 'translations',
      )
      
  const translations = translationsFirst.translations?.map((t) => t.content) || [];

  const values = {
    lang,
    langCode,
    cssClass: dwtcPage.cssClass,
    translations,
  };

  const memo = useMemo(() => values, [values]);

  const dir = langCode === 'ar' ? 'rtl' : 'ltr';

  const body = _.isEmpty(dwtcPage.pageBlocks) ? dwtcPage.dwtc_body : dwtcPage.pageBlocks;

  return (
    <DWTCContext.Provider value={memo}>
      <Layout dir={dir}>
        <Seo page={dwtcPage} lang={langCode} dir={dir} />
        {_.isEqual(dwtcPage.cssClass, 'fullscreen') || (
          <TopBar
            currentClass={dwtcPage.cssClass}
            isHome={_.includes(dwtcPage.cssClass, 'isHome')}
            settings={settings}
            currentPage={{
              id: dwtcPage.id,
              url: dwtcPage.url,
              udi: `umb://document/${dwtcPage.id.replace(/-/g, '')}`,
            }}
            lang={langCode}
            dir={dir}
          />
        )}
        {_.map(body, (item, key) => {
          const contentType = _.get(item, 'content.contentTypeAlias');
          const block = _.get(item, 'content', null);
          const Comp = MAP_COMPONENTS[contentType];
          const hasComponent = _.isFunction(Comp);
          const id = `${contentType}_${key + 1}`;

          const commonProps = {
            data: block,
            dir,
            allEvents,
            lang: langCode,
            settings,
          };

          return block && hasComponent && <Comp key={id} id={id} {...commonProps} />;
        })}
        {_.isEqual(dwtcPage.cssClass, 'fullscreen') || (
          <Footer settings={settings} lang={langCode} dir={dir} />
        )}
      </Layout>
    </DWTCContext.Provider>
  );
}

export const query = graphql`
  query ($id: ID!, $lang: String!) {
    umbraco {
      dwtcPage: content(id: $id, culture: $lang) {
        ...Home
        ...Page
      }
    }
  }
`;
